import { makeStyles } from "@material-ui/styles";

export const useStyles = makeStyles(() => ({
	textUnderline: {
		textDecoration: "underline"
	}
}));
